import { BADGE_VARIANTS } from 'components/Badge'
import { type StatusBadgeMapper } from './types'

export const QUOTE_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  PENDING: {
    variant: BADGE_VARIANTS.GRAY,
    text: 'Pending',
  },
  DRAFT: {
    variant: BADGE_VARIANTS.GRAY,
    text: 'Draft',
  },
  SENT: {
    variant: BADGE_VARIANTS.BLUE,
    text: 'Sent',
  },
  APPROVED: {
    variant: BADGE_VARIANTS.GREEN,
    text: 'Approved',
  },
  EXPIRED: {
    variant: BADGE_VARIANTS.ORANGE,
    text: 'Expired',
  },
  CANCELLED: {
    variant: BADGE_VARIANTS.RED,
    text: 'Cancelled',
  },
} as const
